<div
  class="container"
  #selectInputContainer
  [pplPopover]="selectDropdown"
  [pplPopoverDisabled]="disabled || readonly"
  [pplPopoverAlignStart]="dropdownAlignStart"
  [pplPopoverAlignEnd]="dropdownAlignEnd"
  [class.disabled]="disabled"
  [class.readonly]="readonly"
  [class.active]="!(disabled || readonly) && (opened || focused)"
  (mousedown)="calculateDropdownAlignment()"
  (pplPopoverToggle)="opened = $event.visible; dropdownOpenChange.emit(opened)"
  tabindex="-1">
  <div
    #input
    class="input"
    (focus)="onFocus()"
    (blur)="onBlur()"
    [attr.tabindex]="disabled || readonly ? null : 0"
    (keydown)="onValueInputKeyDown($event); calculateDropdownAlignment()"
    title="{{ selectedOption ? selectedOption.label : placeholder }}">
    <ng-container
      *ngTemplateOutlet="
        optionTemplate;
        context: {
          $implicit: selectedOption,
          selected: true,
          useSelectedLabel: true,
        }
      "></ng-container>
  </div>
  <div
    class="btn dropdown-button"
    [class.active]="!(disabled || readonly) && !opened && focused"
    [class.disabled]="disabled"
    [class.readonly]="readonly"
    [class.opened]="opened"
    tabindex="-1">
    @switch (ngUiTheme) {
      @default {
        <ppl-icon
          [svgIcon]="!disabled ? 'rowline-form' : 'rowline-form_disabled'"
          class="dropdown-icon"
          width="12px"
          height="12px"
          legacyWidth="7px"
          legacyHeight="7px"></ppl-icon>
      }
      @case ('material') {
        <ppl-icon
          class="dropdown-button-icon"
          svgIcon="arrow-down-gray"
          width="12px"
          height="6px"></ppl-icon>
      }
      @case ('fabric') {
        <svg
          class="dropdown-button-icon"
          width="12px"
          height="8px">
          <path
            d="m 6 5.5 l 5.25 -4.7 l 0.75 0.7 l -6 5.5 l -6 -5.5 l 0.75 -0.7"
            fill="#323130"></path>
        </svg>
      }
    }
  </div>
</div>

<ng-template
  #optionTemplate
  let-option
  let-selected="selected"
  let-useSelectedLabel="useSelectedLabel">
  <div
    class="option"
    [class.big]="big"
    [class.disabled]="option.disabled"
    [title]="option.labelTooltip || option.label"
    [attr.data-test]="'Select_Option_' + option.value"
    [class.selected]="option.value === value">
    @if (hasIcons) {
      <div class="option-icon">
        <ng-container *ngTemplateOutlet="optionIcon; context: { '\$implicit': option }"></ng-container>
      </div>
    }
    @if (hasColors) {
      <div class="option-color">
        <div
          class="color"
          width="5px"
          height="10px"
          [style.background-color]="option.color"></div>
      </div>
    }
    @if (selected) {
      @if (normalizedSelectedItemTemplate; as template) {
        <ng-container
          *ngTemplateOutlet="
            template;
            context: {
              $implicit: option.label,
              value: option.value,
              option: option,
            }
          "></ng-container>
      } @else {
        <span
          class="option-label"
          [class.placeholder]="selectedOptionIsPlaceholder">
          @if (useSelectedLabel) {
            {{ option.selectedLabel || option.label }}
          }
          @if (!useSelectedLabel) {
            {{ option.label }}
          }
        </span>
      }
    }
    @if (!selected) {
      @if (itemTemplate; as template) {
        <ng-container
          *ngTemplateOutlet="
            template;
            context: {
              $implicit: option.label,
              value: option.value,
              option: option,
            }
          "></ng-container>
      } @else {
        <span
          class="option-label"
          [class.placeholder]="selectedOptionIsPlaceholder">
          @if (useSelectedLabel) {
            {{ option.selectedLabel || option.label }}
          }
          @if (!useSelectedLabel) {
            {{ option.label }}
          }
        </span>
      }
    }
  </div>
</ng-template>

<ng-template
  #optionIcon
  let-option>
  @if (option.icon) {
    @if (hasOptionIconDimensions(option)) {
      <ppl-icon
        class="option-icon"
        [svgIcon]="option.icon.name"
        [width]="option.icon.width"
        [height]="option.icon.height"
        [fill]="option.iconFill || null"></ppl-icon>
    } @else {
      <ppl-icon
        class="option-icon"
        [svgIcon]="option.icon"
        width="18px"
        height="18px"
        [fill]="option.iconFill || null"></ppl-icon>
    }
  }
</ng-template>

<ng-template #selectDropdown>
  @if (!(disabled || readonly)) {
    <ppl-popover-dropdown
      [style.min-width.px]="popoverWidth === undefined ? dropdownMinWidth : undefined"
      [style.max-width.px]="popoverWidth === undefined ? dropdownMaxWidth : undefined"
      class="dropdown">
      <ppl-option-list-with-filter
        [categories]="categories"
        [displayCategoriesSidebar]="displayCategoriesSidebar"
        [options]="normalizedOptions"
        [optionTemplate]="optionTemplate"
        [value]="value"
        [maxContainerHeight]="optionListMaxContainerHeight"
        [optionTemplateRowHeight]="optionTemplateRowHeight"
        [displaySearch]="displaySearch && normalizedOptions.length >= minItemsToShowSearch"
        [style.width.px]="popoverWidth"
        [categoriesSidebarWidth]="categoriesSidebarWidth"
        [displayAllCategories]="displayAllCategories"
        [displayLoading]="displayLoading"
        (optionSelect)="onOptionSelect($event)"
        (keyEscapePressed)="onKeyEscapePressed()">
        <ng-content
          select="dropdownContentBeforeList"
          ngProjectAs="contentAfterSearch"></ng-content>
      </ppl-option-list-with-filter>
    </ppl-popover-dropdown>
  }
</ng-template>
